export default __webpack_public_path__ + "static/media/woman_login.fa035119.png";